import script from "./pay-success.vue?vue&type=script&setup=true&lang=ts"
export * from "./pay-success.vue?vue&type=script&setup=true&lang=ts"

import "./pay-success.vue?vue&type=style&index=0&id=4dc9e1d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc9e1d2"]])

export default __exports__